function listGeneral(list) {
	const { points, cost, children, alerts = [] } = list;

	// Check points
	if (cost > points) {
		alerts.push({ message: "Total list cost exceeds the selected points limit." })
	}

	let divinityCount = 0;
	let theokratorCount = 0;
	let sepulcherCount = 0;
	let wildHuntCount = 0;
	let fireMaharajah = 0;
	let airMaharajah = 0;
	let avatarCount = 0;
	let chariotCount = 0;
	const upgrades = [
		"heirlooms",
		"the-sacred-relics",
		"relics",
		"trove-finds",
		"artefacts",
		"treasures",
		"bestowed-relics",
		"modifications",
		"patron-s-gifts",
		"disciplines",
		"apparatuses",
		"eccentricities",
		"gifts-of-lifebinding"
	];
	const upgradeMap = {};
	const orderUpgradeMap = {};
	const masteries = ["masteries", "dark-blessings", "masteries-weavers"];
	const masteriesMap = {};
	const selectionsMap = {};
	const warlordSlugs = [];
	const warlordRoles = [];
	const allyRoles = [];
	let theists = 0;
	let orders = 0;
	let others = 0;
	let hasSacredRelics = false;
	let suppressMemoriesOfTheRedYears = false;

	let kaChars = 0;
	let chiChars = 0;
	let fuChars = 0;
	let suiChars = 0;
	let muChars = 0;

	let kaItems = 0;
	let chiItems = 0;
	let fuItems = 0;
	let suiItems = 0;
	let muItems = 0;


	children.forEach(w => {
		if (w.type === "avatar") {
			++avatarCount;
			return;
		}

		const characterNode = w.children.find(c => c.type === "character");
		const character = characterNode.listEntry;
		if (character.isWarlord) warlordSlugs.push(character.slug);

		if (["theist-priest", "crusading-noble-lord"].includes(character.slug)) {
			theists++;
			if (character.isWarlord) warlordRoles.push("theists");
			if (characterNode.selections.includes("dynastic-ally")) allyRoles.push("theists");
		} else if (["chapter-mage", "imperial-officer"].includes(character.slug)) {
			others++;
			if (character.isWarlord) warlordRoles.push("imperial");
			if (characterNode.selections.includes("dynastic-ally")) allyRoles.push("imperial");
		} else if (["noble-lord", "mounted-noble-lord"].includes(character.slug)) {
			others++;
			if (character.isWarlord) warlordRoles.push("feudal");
			if (characterNode.selections.includes("dynastic-ally")) allyRoles.push("feudal");
		} else if ([
			"priory-commander-crimson-tower",
			"priory-commander-sealed-temple",
			"priory-commander-sword",
			"errant-of-the-order-of-the-shield",
		].includes(character.slug)) {
			orders++;
			if (character.isWarlord) warlordRoles.push("orders");
			if (characterNode.selections.includes("dynastic-ally")) allyRoles.push("orders");
		}

		if (
			character.slug === "errant-of-the-order-of-the-shield" &&
			(character.isWarlord || characterNode.selections.includes("dynastic-ally"))) {
			suppressMemoriesOfTheRedYears = true;
		}

		const tagGroups = character.tagGroups || character.profiles[0]?.tagGroups || [];
		const roleGroup = tagGroups.find(g => g.slug === "battlefield-role");
		if (roleGroup) {
			const slugs = roleGroup.tags.map(t => t.slug);
			if (slugs.includes("ka")) {
				++kaChars;
			}
			if (slugs.includes("chi")) {
				++chiChars;
			}
			if (slugs.includes("fu")) {
				++fuChars;
			}
			if (slugs.includes("sui")) {
				++suiChars;
			}
			if (slugs.includes("mu")) {
				++muChars;
			}
		}

		characterNode.selections.forEach(s => {
			if (["way-of-the-kensei", "hannya", "kenshibu-dancer"].includes(s)) ++kaItems;
			else if (["unyielding-kata", "trial-of-hakari-ishi", "takigyo-training"].includes(s)) ++chiItems;
			else if (["gunbai", "hauchiwa", "horagai-master"].includes(s)) ++fuItems;
			else if (["kabuki", "shamisen", "fudoshin"].includes(s)) ++suiItems;
			else if (["purification-rites", "flow", "ofuda"].includes(s)) ++muItems;
			else if (s === "first-in-the-fray") {
				const armyRules = list.tagGroups?.find(g => g.slug === "army-rules");
				if (!armyRules?.tags?.find(t => t.slug === "the-ardent-creed") && !list.selections?.find(s => s === "the-ardent-creed")) {
					characterNode.alerts.push({ message: "First in the Fray can only be purchased if the Army is Following the Ardent Creed." });
				}
			} else if (s === "gifted-in-fire") {
				const armyRules = list.tagGroups?.find(g => g.slug === "army-rules");
				if (!armyRules?.tags?.find(t => t.slug === "the-tempered-creed") && !list.selections?.find(s => s === "the-tempered-creed")) {
					characterNode.alerts.push({ message: "Gifted in Fire can only be purchased if the Army is Following the Tempered Creed." });
				}
			}
			else if (["lathander-sacrifice", "sword-of-the-first-order", "oathstone", "hammer-drill", "oath-unbroken", "like-gods-among-men"].includes(s)) hasSacredRelics = true;
		})


		if (character.slug === "fallen-divinity") {
			divinityCount++;
			if (!character.isWarlord) {
				alerts.push({ message: "The Fallen Divinity must always be selected to be the Warlord." });
			}
		} else if (character.slug === "maharajah") {
			if (characterNode.selections.includes("court-of-fire")) fireMaharajah++;
			if (characterNode.selections.includes("court-of-air")) airMaharajah++;
		}

		if (character.slug === "theokrator") {
			theokratorCount++;
		}

		const regiments = w.children.filter(c => c.type !== "character");
		regiments.forEach(r => {
			if (r.listEntry.slug === "unhallowed-sepulcher") sepulcherCount += 1;
			if (r.listEntry.slug === "the-wild-hunt") wildHuntCount += 1;
			if (r.listEntry.slug === "war-chariots") chariotCount += 1;

			r.selections.forEach(s => {
				selectionsMap[s] = selectionsMap[s] ? selectionsMap[s] + 1 : 1;
			})

			const { groups = [] } = r.listEntry.options || {};
			const upgradeGroup = groups.find(g => g.slug === "order-regiment-upgrades");
			if (upgradeGroup) {
				const hasSelections = upgradeGroup.orphans.map(o => o.selected).some(v => v === true);
				if (hasSelections) {
					orderUpgradeMap[r.entrySlug] ??= 0;
					orderUpgradeMap[r.entrySlug]++;
					if (orderUpgradeMap[r.entrySlug] > 1) {
						alerts.push({ message: `"${r.listEntry.name}" Army List entries may only take one Order Upgrade in total.` });
					}
				}
			}
		})

		const { groups = [] } = character.options;
		const upgradeGroups = groups.filter(g => upgrades.includes(g.slug)) || [];
		upgradeGroups.forEach(u => {
			const { groups: subgroups = [], orphans = [] } = u;
			orphans.forEach(o => {
				if (o.selected) {
					upgradeMap[o.name] = upgradeMap[o.name] ? upgradeMap[o.name] + 1 : 1;
				}
			});

			subgroups.forEach(g => {
				g.orphans.forEach(o => {
					if (o.selected) {
						upgradeMap[o.name] = upgradeMap[o.name] ? upgradeMap[o.name] + 1 : 1;
					}
				});
			});
		})

		const masteriesGroup = groups.find(g => masteries.includes(g.slug)) || {};
		const { groups: subgr = [], orphans = [] } = masteriesGroup;
		orphans.forEach(o => {
			if (o.selected) {
				masteriesMap[o.name] = masteriesMap[o.name] ? masteriesMap[o.name] + 1 : 1;
			}
		});

		subgr.forEach(g => {
			g.orphans.forEach(o => {
				if (o.selected) {
					masteriesMap[o.name] = masteriesMap[o.name] ? masteriesMap[o.name] + 1 : 1;
				}
			});
		});


	});

	if (kaItems > kaChars) {
		alerts.push({ message: "Ka Disciplines have exceeded the number of Ka Characters." });
	}
	if (chiItems > chiChars) {
		alerts.push({ message: "Chi Disciplines have exceeded the number of Chi Characters." });
	}
	if (fuItems > fuChars) {
		alerts.push({ message: "Fu Disciplines have exceeded the number of Fu Characters." });
	}
	if (suiItems > suiChars) {
		alerts.push({ message: "Sui Disciplines have exceeded the number of Sui Characters." });
	}
	if (muItems > muChars) {
		alerts.push({ message: "Mu Disciplines have exceeded the number of Mu Characters." });
	}

	if (theists > 0 && orders > 0 && !suppressMemoriesOfTheRedYears) {
		alerts.push({ message: "The Army List cannot include a [Theist] [Character] and a [The Orders] [Character] at the same time." });
	}
	if ((theists > 0 || others > 0) && hasSacredRelics) {
		alerts.push({ message: "Your Army must only contain [The Orders] [Character]s in order to gain access to \"The Sacred Relics\"." });
	}
	if ((theists > 0 || others > 0) && Object.keys(orderUpgradeMap).length > 0) {
		alerts.push({ message: "Your Army must only contain [The Orders] [Character]s in order to gain access to \"Order Regiment Updates\"." });
	}

	const rolesIntersection = warlordRoles.filter(r => allyRoles.includes(r))
	if (rolesIntersection.length > 0) {
		alerts.push({ message: "A \"Dynastic Ally\" cannot share the same Sub-Faction Battlefield Role with the Warlord." });
	}
	if (allyRoles.length > 1) {
		alerts.push({ message: "Only one Character can be selected to be a \"Dynastic Ally\"." });
	}

	if (wildHuntCount > 0 && avatarCount > 0) {
		alerts.push({ message: "You may not purchase a Wild Hunter if the Army contains The Wild Hunt Regiment." });
	}

	if (avatarCount > 3) {
		alerts.push({ message: "You may not purchase more than 3 Wild Hunters." });
	}

	if (wildHuntCount > 1) {
		alerts.push({ message: "You may not purchase more than 1 The Wild Hunter Regiments." });
	}

	if (chariotCount > 5) {
		alerts.push({ message: "War Chariots are limited to max 5 Regiments per Army." });
	}

	// if (list.factionSlug === "the-hundred-kingdoms") {
	// 	const countLords = warlordSlugs.filter(s => ["noble-lord", "mounted-noble-lord"].includes(s)).length;
	// 	const countPriories = warlordSlugs.filter(s => ["priory-commander-sword", "priory-commander-crimson-tower", "priory-commander-sealed-temple"].includes(s)).length;
	// 	const countPriests = warlordSlugs.filter(s => s === "theist-priest").length;
	// 	const countOfficers = warlordSlugs.filter(s => s === "imperial-officer").length;
	// 	const countMages = warlordSlugs.filter(s => s === "chapter-mage").length;

	// 	const warlordCount =
	// 		(countLords > 0 ? 1 : 0) +
	// 		(countPriories > 0 ? 1 : 0) +
	// 		(countPriests > 0 ? 1 : 0) +
	// 		(countOfficers > 0 ? 1 : 0) +
	// 		(countMages > 0 ? 1 : 0);

	// 	if (warlordCount < 1 && children.length > 0) {
	// 		alerts.push({ message: "A Character must be selected to be the Warlord." })
	// 	}
	// 	if (warlordCount > 2) {
	// 		alerts.push({ message: "Up to two Characters can be selected as Warlords." })
	// 	}

	// 	if (countLords > 1) {
	// 		alerts.push({ message: "Only one Noble Lord can be selected as Warlord." })
	// 	}

	// 	if (countPriories > 1) {
	// 		alerts.push({ message: "Only one Priory Commander can be selected as Warlord." })
	// 	}

	// 	if (countPriests > 1) {
	// 		alerts.push({ message: "Only one Theist Priest can be selected as Warlord." })
	// 	}

	// 	if (countOfficers > 1) {
	// 		alerts.push({ message: "Only one Imperial Officer can be selected as Warlord." })
	// 	}

	// 	if (countMages > 1) {
	// 		alerts.push({ message: "Only one Chapter Mage can be selected as Warlord." })
	// 	}
	// } else {
	const warlordCount = warlordSlugs.length;

	if (warlordCount < 1 && children.length > 0) {
		alerts.push({ message: "A Character must be selected to be the Warlord." })
	}
	if (warlordCount > 1) {
		alerts.push({ message: "Only one Character can be selected to be the Warlord." })
	}
	// }

	if (divinityCount > 1) {
		alerts.push({ message: "Only one Fallen Divinity can be added to the list." });
	}

	// if (fireMaharajah > 1) {
	// 	alerts.push({ message: "Only one Maharajah from the Court of Fire can be added to the list." });
	// }

	// if (airMaharajah > 1) {
	// 	alerts.push({ message: "Only one Maharajah from the Court of Air can be added to the list." });
	// }

	// if (sepulcherCount > 1) {
	// 	alerts.push({ message: "Only one Unhallowed Sepulcher can be added to the list." });
	// }

	if (theokratorCount > 0 && divinityCount > 0) {
		alerts.push({ message: "The Theokrator cannot be fielded in the same Army as a Fallen Divinity." });
	}

	const keys = Object.keys(upgradeMap);
	const limitExceptions = [
		"Avatar Projection"
	];
	keys.forEach(k => {
		if (upgradeMap[k] > 1 && !limitExceptions.includes(k)) {
			alerts.push({ message: `${k} can only appear once in the Army.` });
		}
	});

	const mkeys = Object.keys(masteriesMap);
	const exceptions = [
		"Apex Master",
		"Tontorr Rider",
		"Drum Beast Rider",
		"Hellbringer Sorcerer",
		"Ferric Throne",
		"Master of Flesh",
		"Chitinous Metamorphosis",
		"Cloud Seeding"
	];
	mkeys.forEach(k => {
		if (masteriesMap[k] > 1 && !exceptions.includes(k)) {
			alerts.push({ message: `${k} can only appear once in the Army.` });
		}
	});

	// TODO: Names should not be defined here, but retrieved from the faction data.
	// It can be done by digging through the list entry but it's too much trouble.
	// Consider moving all options outside the entries like the entries themselves
	// compared to the entrygroups. The problem with that is that they would need
	// to have unique names.
	const onePerListOptions = [
		{ name: "Mnemancer's Apprentice", slug: "mnemancer-s-apprentice" },
	];

	onePerListOptions.forEach(o => {
		if (selectionsMap[o.slug] > 1) {
			alerts.push({ message: `${o.name} can only appear once in the Army.` });
		}
	})
}


export default listGeneral;